<template>
    <Layout>
        <div class="bg-gray-50 py-12 md:py-20">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center mb-12 md:mb-16">
                    <h1 class="text-4xl sm:text-5xl font-extrabold text-[#00395a] tracking-tight">Mahila Mandal</h1>
                    <p class="mt-4 text-lg sm:text-xl text-black max-w-3xl mx-auto font-medium">
                        Shri Ghoghari Lohana Mahila Samaj - Empowering women within our community through various activities and initiatives.
                    </p>
                </div>

                <div class="bg-white p-6 sm:p-8 mb-12 md:mb-16">
                    <h2 class="text-2xl sm:text-3xl font-bold text-[#00395a] mb-6">About Mahila Mandal</h2>
                    <div class="prose prose-lg text-black max-w-none font-medium">
                        <p>Under the able leadership of Mrs. Ushaben Vajani, the women’s wing carries out a number of activities and events for the welfare of the community. These include picnics, Indoor Games, Bhajan Sandhya, Navratri Ras Garba, Cooking Demonstrations, Sarasvati Sanman, food distribution, various competitions, and other engaging events.</p>
                        <p>Currently, our membership proudly stands at 1100 members. To enroll for membership or to inquire about the activities of Mahila Samaj, kindly contact the Mahajan office at <a href="tel:02226283715" class="text-[#00395a] hover:underline font-medium">022 26283715</a>.</p>
                    </div>
                </div>

                <div class="bg-white p-6 sm:p-8">
                    <h2 class="text-2xl sm:text-3xl font-bold text-[#00395a] mb-8 text-center">Office Bearers & Committee</h2>
                    
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        
                        <div class="committee-section">
                            <h3 class="text-xl font-semibold text-[#00395a] mb-3 border-b pb-2 text-left">Chairperson</h3>
                            <ul class="list-disc list-inside text-black space-y-1  text-left font-medium">
                                <li>Smt. Rashmiben Vithalani</li>
                            </ul>
                        </div>

                        <div class="committee-section">
                            <h3 class="text-xl font-semibold text-[#00395a] mb-3 border-b pb-2 text-left">President</h3>
                            <ul class="list-disc list-inside text-black space-y-1 text-left font-medium">
                                <li>Smt. Rashmiben Vithalani</li>
                            </ul>
                        </div>

                        <div class="committee-section">
                            <h3 class="text-xl font-semibold text-[#00395a] mb-3 border-b pb-2 text-left">Vice Presidents</h3>
                            <ul class="list-disc list-inside text-black space-y-1 text-left font-medium">
                                <li>Smt. Ilaben Popat</li>
                                <li>Smt. Veenaben Magdani</li>
                            </ul>
                        </div>

                        <div class="committee-section md:col-span-2 lg:col-span-1"> <!-- Allow trustees to span more on medium if needed -->
                            <h3 class="text-xl font-semibold text-[#00395a] mb-3 border-b pb-2 text-left">Trustees</h3>
                            <ul class="list-disc list-inside text-black space-y-1 text-left font-medium">
                                <li>Smt. Bhavna Tanna</li>
                                <li>Smt. Ramaben Raja</li>
                                <li>Smt. Rajni Sayani</li>
                                <li>Smt. Ushaben Vajani</li>
                                <li>Smt. Chandrika Tanna</li>
                            </ul>
                        </div>

                        <div class="committee-section">
                            <h3 class="text-xl font-semibold text-[#00395a] mb-3 border-b pb-2 text-left">Secretaries</h3>
                            <ul class="list-disc list-inside text-black space-y-1 text-left font-medium">
                                <li>Smt. Madhviben Somaiya</li>
                                <li>Smt. Kanakben Magdani</li>
                            </ul>
                        </div>

                        <div class="committee-section">
                            <h3 class="text-xl font-semibold text-[#00395a] mb-3 border-b pb-2 text-left">Advisor</h3>
                            <ul class="list-disc list-inside text-black space-y-1 text-left font-medium">
                                <li>Smt. Pravinaben Magdani</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </div>
</Layout>
</template>

<script>
import Layout from './../layouts/LayoutView.vue'

export default {
  name: 'MahilaMandalPage',
  components: {
    Layout
  },
  // You can add data fetching here if committee members are dynamic
}
</script>

<style scoped>
.prose a {
    @apply text-[#00395a] no-underline hover:underline;
}
.prose p {
    @apply mb-4;
}
</style>
